import React from 'react';
import { Modal, Typography, Divider, Button, Space } from 'antd';
import { InfoCircleOutlined, CheckCircleOutlined, WarningOutlined, MessageOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

interface HelpModalProps {
  visible: boolean;
  onClose: () => void;
  onContactUs: () => void;
}

const HelpModal: React.FC<HelpModalProps> = ({ visible, onClose, onContactUs }) => {
  return (
    <Modal
      title={
        <Space>
          <InfoCircleOutlined style={{ color: '#1d8fc2' }} />
          <Title level={4} style={{ margin: 0 }}>Earthdaily Crop Identification Product</Title>
        </Space>
      }
      open={visible}
      onCancel={onClose}
      width={600}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
        <Button
          key="contact"
          type="primary"
          icon={<MessageOutlined />}
          onClick={onContactUs}
        >
          Contact Us
        </Button>,
      ]}
    >
      <Divider style={{ margin: '12px 0 24px' }} />
      
      <Title level={5}>About Our Data</Title>
      <Paragraph>
        Our Crop Identification product combines satellite imagery, weather data, and advanced AI models to accurately detect what crops are planted and where - all during the active growing season, at national scale.
  </Paragraph>
    <Paragraph>
Get access to the full documentation by visiting our <a href="https://earthdaily.github.io/earthdaily-documentation/Agro/Cropid/crop_identification_overviewPage/" target="_blank" rel="noopener noreferrer">Documentation Website</a>.
      </Paragraph>
      
      

    </Modal>
  );
};

export default HelpModal;